<app-nav-menu></app-nav-menu>
<main class="main">
  <div class=" cms_main fadeInUp animated">
    <div class="cms_card">

      <!--<div class="row-card">-->
      <div class="row">
        <div class="col-md-8">
          <div class="cms_card-heading">Offline Booking List</div>
        </div>
        <div class="col-md-2">
          <!--<ng-select [items]="requestTypeList$ | async"
                     bindLabel="requestTypeName" bindValue="requestTypeId"
                     [searchable]="true"
                     [ngModelOptions]="{standalone: true}"
                     placeholder="Select Request Type"
                     [(ngModel)]="requestTypeId"
                     (change)="OnRequestTypeChange(requestTypeId)"
                     >
          </ng-select>-->
        </div>
        <div class="col-md-2 position-req-new">
          <br />
          <!--<a class="card-icon" (click)="AddNewRequest()">
            <i class="uil uil-file-plus-alt card_custom-icon"></i>Add New
          </a>-->
          <!--<button class="Add-new-request-btn" ><i class="uil uil-plus-circle accor_icon"></i> Add New </button>-->

        </div>
      </div>
      <div class="row">

        <div class="devextr">


          <!--</div>-->

          <dx-data-grid [dataSource]="requestList"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [allowColumnResizing]="true"
                        (onContentReady)="contentReady($event)"
                         (onCellPrepared)="onCellPrepared($event)">
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxi-column [allowFiltering]="true" [visible]="false" alignment="center" caption="Request Type Id" dataField="requestType" dataType="string"></dxi-column>
           
            <dxi-column [allowFiltering]="true" alignment="center" caption="Request Type" dataField="requestTypeName" dataType="string" format="dd-MM-yyyy"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" caption="Booking date" dataField="creationDate" dataType="Date" format="dd-MM-yyyy"></dxi-column>
            <dxi-column [allowFiltering]="true" [visible]="false" alignment="center" caption="BookingId" dataField="offlineBookingId"></dxi-column>
            <dxi-column [allowFiltering]="true" [visible]="false" alignment="center" caption="agency Id" dataField="agencyid"></dxi-column>
            <dxi-column [allowFiltering]="true"  alignment="center" caption="Booking Id" dataField="bookingAgencyId"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" caption="Supplier" dataField="bookingSource" dataType="string"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" caption="Pnr" dataField="pnr" dataType="string"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" caption="Ticket No" dataField="tktNo" dataType="string"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" caption="Trip" dataField="sector" dataType="string"></dxi-column>

            <!--<dxi-column alignment="center" caption="Type" dataField="type" dataType="string"></dxi-column>-->
            <dxi-column [allowFiltering]="true" alignment="center" caption="Passenger Name" dataField="passName" dataType="string"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" [visible]="false" dataField="onlineBookingId" dataType="number"></dxi-column>




            <!--<dxi-column [allowFiltering]="true" alignmnet="center" caption="No of Pass" dataField="noOfPass" dataType="number"></dxi-column>-->

            <dxi-column [allowFiltering]="true" alignment="center" caption="Travel date" dataField="travelDate" dataType="Date" format="dd-MM-yyyy"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" caption="Status" dataField="status" dataType="string"></dxi-column>
            <dxi-column caption="Action" type="buttons" [width]="60">
              <dxi-button hint="Edit"
                          icon="edit"
                          [onClick]="onClickEditRequest"></dxi-button>
            </dxi-column>

            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>



          </dx-data-grid>

        </div>
      </div>
    </div>
  </div>
</main>
